var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRatingStarIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 30",
    fill: "#325AFF",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 25l-6.626 4.047a2.5 2.5 0 01-3.735-2.713L7.44 18.78 1.544 13.73A2.5 2.5 0 012.97 9.34l7.74-.621 2.981-7.17a2.5 2.5 0 014.617 0l2.982 7.17 7.74.62a2.5 2.5 0 011.426 4.391l-5.897 5.051 1.802 7.553a2.5 2.5 0 01-3.735 2.713L16 25z",
    fill: "inherit"
  })));
}
export default SvgRatingStarIcon;